/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import HttpsRedirect from 'react-https-redirect';
import { create } from 'jss';

import { StylesProvider, createGenerateClassName, jssPreset } from '@mui/styles';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';

import theme from './styles/theme';
import reduxStore from './redux/store';
import LoggedInRoute from './logged-in-route';
import Home from './components/home';
import ErrorPage from './components/error-page';
import AdminAccountSelector from './components/admin/admin-account-selector';
//import LoginForm from './components/login-form/login-form';
import HomeTopNav from './components/top-nav/home-top-nav';
//import Pricing from './components/composer/pricing';
//import Overview from './components/composer/overview';
import Footer from './components/footer';
import ScrollToTop from './utils/scroll-to-top';
//import Features from './components/composer/features';
//import Faqs from './components/composer/faqs';
// import Resources from './components/composer/resources';
import Dashboard from './components/dashboard';
import ServicesTopNav from './components/top-nav/services-top-nav';
import ApiKeys from './components/composer/api-keys/api-keys';
import ApiKeysEdit from './components/composer/api-keys/api-keys-edit';
import ApiKeysView from './components/composer/api-keys/api-keys-view';
import StreamComposer from './components/composer/stream-composer';
import ReachExtension from './components/composer/reach-extension';
import Api from './components/composer/api';
import CreativeStudio from './components/composer/creative-studio';
import Privacy from './components/composer/privacy';
import Security from './components/composer/security';
import Demo from './components/composer/demo';

const generateClassName = createGenerateClassName();
const jss = create(jssPreset());

export const IndexApp = ({ store }) => (
  <StylesProvider jss={jss} generateClassName={generateClassName}>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <HttpsRedirect>
            <Router>
              <Switch>
                {/* <Route exact path={['/login', '/sign-up']}>
                  <LoginForm />
                </Route> */}

                <LoggedInRoute exact path="/dashboard">
                  <ServicesTopNav selectedService="Dashboard" />
                  <Dashboard />
                </LoggedInRoute>

                <LoggedInRoute path="/api-keys">
                  <ServicesTopNav selectedService="API Keys" />
                  <Switch>
                    <Route exact path="/api-keys/create">
                      <ApiKeysEdit />
                    </Route>
                    <Route exact path="/api-keys/:oAuthApplicationId">
                      <ApiKeysView />
                    </Route>
                    <Route exact path="/api-keys/:oAuthApplicationId/edit">
                      <ApiKeysEdit />
                    </Route>
                    <Route exact path="/api-keys">
                      <ApiKeys />
                    </Route>
                  </Switch>
                </LoggedInRoute>

                <LoggedInRoute exact path="/select-account">
                  <ServicesTopNav selectedService="Select Account" />
                  <AdminAccountSelector />
                </LoggedInRoute>

                <Route path="/">
                  <HomeTopNav />
                  <Switch>
                    {/* <Route exact path="/overview">
                      <Overview />
                    </Route>
                    <Route exact path="/features">
                      <Features />
                    </Route>
                    <Route exact path="/pricing">
                      <Pricing />
                    </Route> */}
                    <Route path="/stream-composer">
                      <ScrollToTop />
                      <StreamComposer />
                    </Route>
                    <Route path="/reach-extension">
                      <ScrollToTop />
                      <ReachExtension />
                    </Route>
                    <Route path="/creative-studio">
                      <ScrollToTop />
                      <CreativeStudio />
                    </Route>
                    <Route path="/api">
                      <ScrollToTop />
                      <Api />
                    </Route>
                    {/* <Route path="/resources">
                      <ScrollToTop />
                      <Resources />
                    </Route> */}
                    <Route path={['/demo', '/demo/:category']}>
                      <Demo />
                    </Route>
                    <Route path="/privacy">
                      <ScrollToTop />
                      <Privacy />
                    </Route>
                    <Route path="/security">
                      <ScrollToTop />
                      <Security />
                    </Route>
                    {/* <Route exact path="/faqs">
                      <Faqs />
                    </Route> */}
                    <Route path="/">
                      <ScrollToTop />
                      <Home />
                    </Route>
                  </Switch>
                  <Footer />
                </Route>

                <Route path="*">
                  <ErrorPage errorCode={404} description="Sorry, we couldn't find the page you're looking for." />
                </Route>
              </Switch>
            </Router>
          </HttpsRedirect>
        </Provider>
      </ThemeProvider>
    </StyledEngineProvider>
  </StylesProvider>
);

IndexApp.propTypes = {
  store: PropTypes.shape({}),
};

IndexApp.defaultProps = {
  store: reduxStore,
};
